(() => {
  'use strict';
  const specHeadings = /^(?:specifications?|specifikationer|specifikation|spesifikasjoner|tekniset tiedot|specificaties)$/i;
  function parseSpecRows(values) {
    if (!values.length) return null;
    const rows = values.map(value => {
      const match = value.trim().match(/^([^:]{1,64}):\s*(\S[\s\S]*)$/);
      return match && match[1].trim() ? [match[1].trim(), match[2].trim()] : null;
    });
    return rows.every(Boolean) ? rows : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {parseSpecRows};
  if (typeof document === 'undefined') return;
  function enhance(root) {
    if (root.dataset.nmEnhanced) return;
    root.dataset.nmEnhanced = 'true';
    const copy = root.querySelector('.nm-product-description__copy');
    // Block/list boundaries already provide separation. Keep useful inline breaks.
    const adjacent = (node, direction) => {
      let other = node[direction];
      while (other?.nodeType === 3 && !other.textContent.trim()) other = other[direction];
      return other;
    };
    copy.querySelectorAll('br').forEach(br => {
      const parent = br.parentElement;
      const block = /^(P|UL|OL|LI|DIV|H[1-6]|TABLE)$/;
      const next = adjacent(br, 'nextSibling'), prev = adjacent(br, 'previousSibling');
      if (next?.nodeName === 'BR' || block.test(next?.nodeName || '') || block.test(prev?.nodeName || '') ||
          ((!next || !prev) && (parent === copy || /^(UL|OL)$/.test(parent.tagName)))) br.remove();
    });
    const heading = Array.from(copy.children).find(el => specHeadings.test(el.textContent.trim()));
    const list = heading?.nextElementSibling;
    if (!list || !/^(UL|OL)$/.test(list.tagName)) return;
    const items = Array.from(list.children);
    if (items.some(el => el.tagName !== 'LI' || el.querySelector('a,img,video,iframe,table,ul,ol,br'))) return;
    const rows = parseSpecRows(items.map(el => el.textContent));
    if (!rows) return; // Unrecognized formats keep every original node.
    const aside = document.createElement('aside'); aside.className = 'nm-product-specs';
    const title = document.createElement('h3'); title.textContent = heading.textContent.trim();
    title.id = root.id + '-specs'; aside.setAttribute('aria-labelledby', title.id);
    const table = document.createElement('table'), body = table.createTBody();
    rows.forEach(([key,value]) => {
      const row = body.insertRow(), label = document.createElement('th');
      label.scope = 'row'; label.textContent = key; row.append(label);
      row.insertCell().textContent = value;
    });
    aside.append(title, table);
    heading.remove(); list.remove();
    const layout = root.querySelector('.nm-product-description__layout');
    layout.append(aside); layout.classList.add('nm-has-specs');
  }
  const init = () => document.querySelectorAll('.nm-product-description').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
